import { Typography } from '@material-tailwind/react';
import React from 'react';

function CompanyTrust() {
    return (
      <div className='mb-16'>
        <Typography variant='h4' className='px-7 text-center underline underline-offset-8'>Temukan Lowongan Kerja Di Perusahan Impian</Typography>
        <div className='grid grid-cols-2 md:grid-cols-4 py-10'>
          <img className='m-auto' src="1.png" alt="Foto Company" />
          <img className='m-auto' src="2.png" alt="Foto Company" />
          <img className='m-auto' src="3.png" alt="Foto Company" />
          <img className='m-auto' src="4.png" alt="Foto Company" />
          <img className='m-auto' src="5.png" alt="Foto Company" />
          <img className='m-auto' src="6.png" alt="Foto Company" />
          <img className='m-auto' src="7.png" alt="Foto Company" />
          <img className='m-auto' src="8.png" alt="Foto Company" />
        </div>
      </div>
  )
}

export default CompanyTrust